import React from 'react';
import { ConfigProvider, Menu, Grid } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import AntdProTable from '@ant-design/pro-table';
import * as ProTableSearch from './ProTableSearch';
import './ProTable.less';

const { useBreakpoint } = Grid;

const ProTable = ({ ...props }) => {
  const screens = useBreakpoint();

  // console.log(screens);

  return (
    <ConfigProvider locale={enUS}>
      <AntdProTable
        size={!screens.md ? 'small' : screens.xl ? 'large' : 'middle'}
        scroll={{ x: 800 }}
        {...props}
      />
    </ConfigProvider>
  );
};

export const proTableActionsColumn = ({ menuItems, props }) => ({
  title: 'Actions',
  render: (_, item) => {
    const obj = {
      children: (
        <Menu mode="horizontal" selectable={false}>
          {menuItems(item)}
        </Menu>
      ),
      props,
    };

    return obj;
  },
  ellipsis: true,
});

export const renderProTableSearchProjectCategory = (
  _,
  { type, _defaultValue, ...rest },
  _form
) =>
  type === 'form' ? null : (
    <ProTableSearch.ProTableSearchProjectCategory {...rest} />
  );

export const renderProTableSearchFundingSource = (
  _,
  { type, _defaultValue, ...rest },
  _form
) =>
  type === 'form' ? null : (
    <ProTableSearch.ProTableSearchFundingSource {...rest} />
  );

export const renderProTableSearchProjectStatus = (
  _,
  { type, _defaultValue, ...rest },
  _form
) =>
  type === 'form' ? null : (
    <ProTableSearch.ProTableSearchProjectStatus {...rest} />
  );

export const renderProTableSearchFaculty = (
  _,
  { type, _defaultValue, ...rest },
  form
) => {
  if (type === 'form') {
    return null;
  }
  delete rest.defaultRender;

  return <ProTableSearch.ProTableSearchFaculty form={form} {...rest} />;
};

export const renderProTableSearchDepartment = (
  _,
  { type, _defaultValue, ...rest },
  form
) => {
  if (type === 'form') {
    return null;
  }
  const faculty = form.getFieldValue('faculty');
  delete rest.defaultRender;

  return (
    <ProTableSearch.ProTableSearchDepartment faculty={faculty} {...rest} />
  );
};

export const renderProTableSearchTeamMember = (
  _,
  { type, _defaultValue, ...rest },
  _form
) => {
  if (type === 'form') {
    return null;
  }

  return <ProTableSearch.ProTableSearchTeamMember {...rest} />;
};

export const renderProTableSearchProjectApplicationSetting = (
  _,
  { type, _defaultValue, ...rest },
  _form
) => {
  if (type === 'form') {
    return null;
  }

  return <ProTableSearch.ProTableSearchProjectApplicationSetting {...rest} />;
};

export default ProTable;
